// ServicesByType.tsx
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";

interface Props {
  data: { tipo: string; quantidade: number }[];
}

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042"];

export function ServicesbyType({ data }: Props) {
  const total = data.reduce(
    (acc, item) => acc + item.quantidade,
    0
  );

  const renderLabel = (entry: any) => {
    const percent = total
      ? ((entry.quantidade / total) * 100).toFixed(0)
      : 0;

    return `${entry.tipo} (${percent}%)`;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          dataKey="quantidade"
          nameKey="tipo"
          outerRadius={100}
          label={renderLabel}
        >
          {data.map((_, index) => (
            <Cell
              key={index}
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
}